function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#da0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9f0000"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_53",
  "data-name": "Group 53",
  transform: "translate(-3303.687 -3247.416)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M3329.387,3247.708a8.524,8.524,0,0,1,5.755.478h0a8.543,8.543,0,0,0,7.089,0h0a8.546,8.546,0,0,1,10.5,2.814h0a8.543,8.543,0,0,0,6.139,3.544h0a8.546,8.546,0,0,1,7.687,7.687h0a8.547,8.547,0,0,0,3.544,6.139h0a8.543,8.543,0,0,1,2.814,10.5h0a8.543,8.543,0,0,0,0,7.089h0a8.542,8.542,0,0,1-2.814,10.5h0a8.547,8.547,0,0,0-3.544,6.139h0a8.543,8.543,0,0,1-7.687,7.687h0a8.552,8.552,0,0,0-6.139,3.544h0a8.542,8.542,0,0,1-10.5,2.814h0a8.543,8.543,0,0,0-7.089,0h0a8.543,8.543,0,0,1-10.5-2.814h0a8.547,8.547,0,0,0-6.138-3.544h0a8.546,8.546,0,0,1-7.688-7.687h0a8.538,8.538,0,0,0-3.544-6.139h0a8.546,8.546,0,0,1-2.814-10.5h0a8.543,8.543,0,0,0,0-7.089h0a8.547,8.547,0,0,1,2.814-10.5h0a8.538,8.538,0,0,0,3.544-6.139h0a8.548,8.548,0,0,1,7.688-7.687h0a8.539,8.539,0,0,0,6.138-3.544h0A8.526,8.526,0,0,1,3329.387,3247.708Z",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_52",
  "data-name": "Group 52"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M3328.116,3270.644a3.05,3.05,0,1,1,3.049,3.049A3.048,3.048,0,0,1,3328.116,3270.644Zm21.692-3.814a12.982,12.982,0,0,0-2.688-2.629,6.688,6.688,0,0,1,1.939-2.291c-3.06-1.446-5.265,2.716-8.325,1.269l.75,4.919C3344.543,3269.545,3346.749,3265.383,3349.808,3266.83Zm8.478,33.961-39.2.007c3.072-2.125,6.36-4.3,9.536-6.215a1.357,1.357,0,0,1-.481-1.034v-14.824a2.241,2.241,0,0,0-.821-1.469l-3.168-3.019c-.384-.391-2.428-4.593-2.428-4.593a1.121,1.121,0,0,1,1.995-1.024l2.118,4.124,1.583,1.51c.634.6,1.3.1,2.722,0l.914,1.289-.922,6.45,1.029,1.2,1.029-1.2-.922-6.449.915-1.289a8.912,8.912,0,0,1,3.539,1.126c.405.3,2.515,3.184,2.515,3.184l2.837-.135-2.223-14.582a.641.641,0,0,1,1.268-.193l2.244,14.715a1.121,1.121,0,0,1,.335,2.2l1.027,6.738a.642.642,0,0,1-1.269.194l-1.043-6.843-3.709.174a1.1,1.1,0,0,1-.889-.437l-1.918-2.488c-.465-.033-.713.492-.713.713v6.129l1.673,5.878c2.828-1.335,5.276-2.16,7-2.16,4.442,0,12.383,4.653,15.421,7.06Zm-24.889-8.927-1.981-6.3h-.5v7.667C3331.758,3292.752,3332.588,3292.293,3333.4,3291.864Z",
  fill: "#fbb03b"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  cx: 29.15,
  cy: 29.15,
  r: 29.15,
  transform: "translate(3309.537 3253.266)",
  fill: "none",
  stroke: "#fbb03b",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

var SvgGolfmanOn = function SvgGolfmanOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGolfmanOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/golfman-on.b3851f10.svg";
export { ForwardRef as ReactComponent };